import * as React from 'react';
import { connect } from 'react-redux';

import * as CommentActions from '../../actions/comments';
import * as CommentCreators from '../../creators/comments';

import CommentsList from './CommentList';
import CommentLoader from '../CommentLoader/CommentLoader';
import * as commentImg from '../../assets/image/vector.png';
import * as smileImg from '../../assets/image/smile.png';

import State from '../../interfaces/states/State';

import CommentResults from '../../interfaces/CommentResults';

import './style.scss';

interface DispatchProps {
  commentsValue: (value: string) => void;
  sendComment: () => void;
  comments: () => void;
}

interface OwnProps {
  commentData: CommentResults;
  isLoadingSend: boolean;
  textAreaValue: string;
  isLoading: boolean;
}

interface Props extends DispatchProps, OwnProps {}

function Comments (props: Props) {

  const [messagesEnd, setMessagesEnd] = React.useState(null);
  
  React.useEffect(() => {
    props.comments();
    scrollToBottom();
  }, []);

  React.useEffect(() => {
    scrollToBottom();
  });

  const buttonClick = React.useCallback(() => {
    if (props.textAreaValue) {
      props.sendComment();
      setTimeout(() => {
        scrollToBottom();
      }, 2000);
    } else {
      return null;
    }
  }, [props.textAreaValue, props.sendComment]);

  const getCommentValue = React.useCallback((e) => {
    props.commentsValue(e.target.value);
  }, [props.commentsValue]);

  const scrollToBottom = React.useCallback(() => {
    if (messagesEnd && messagesEnd.scrollIntoView) {
      messagesEnd.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messagesEnd]);

  return(
    <div className='comments-container'>
      <header className='comment-header d-flex align-center'>
        <img
          src={commentImg}
          className='comment-img' /> <span className='comment-head'>{'Comments'}</span>
      </header>
      <div className='profile-hr' />
      <div className='comments-block'>
        {
          props.commentData.results ?
            <CommentsList comments={props.commentData.results} /> :
            null
        }
        <div
          style={{ float: 'left', clear: 'both' }}
          ref={(el) => {
            setMessagesEnd(el);
          }} />
      </div>
      <div className='profile-hr' />
      <footer
        className='comments-footer d-flex align-center justify-around'>
        <img
          className='comments-smile'
          src={smileImg} />
        <div style={{ backgroundColor: '#f9f9fb', alignSelf: 'flex-end', marginBottom: '18px ', position: 'relative' }}>
          <textarea
            disabled={props.isLoadingSend}
            onChange={getCommentValue}
            value={props.textAreaValue}
            style={{ resize: 'none', background: '#f9f9fb' }}
            className='comment-input'
            placeholder='Send a comment...'
          />
        </div>

        <div className='button-wrapper'>
          {
            props.isLoading ?
              <CommentLoader /> :
              <button
                onClick={buttonClick}
                className='comment-button' />
          }
        </div>
      </footer>
    </div>
  );
  
}

const mapStateToProps = (state: State) => {
  return {
    commentData: state.comments.commentData,
    isLoadingSend: state.comments.isLoadingSend,
    textAreaValue: state.comments.textAreaValue,
    isLoading: state.comments.isLoading,
  };
};

const mergeProps = (stateProps, dispatchProps: DispatchProps, props: OwnProps): Props => {
  return {
    ...stateProps,
    commentsValue: dispatchProps.commentsValue,
    sendComment: dispatchProps.sendComment,
    comments: dispatchProps.comments,
    ...props,
  };
};

export default connect(
  mapStateToProps, {
    commentsValue: CommentActions.fetchCommentsValue,
    sendComment: CommentCreators.sendComment,
    comments: CommentCreators.comments,
  }, mergeProps
)(React.memo(Comments));
